var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7321 35.5781C8.47906 35.5781 5.03125 32.1709 5.03125 27.9678C5.03125 23.7648 8.47906 20.3575 12.7321 20.3575C13.2427 20.3575 13.7416 20.4066 14.2243 20.5004M14.2243 20.5004C13.8127 19.4023 13.5878 18.2147 13.5878 16.9752C13.5878 11.3711 18.1849 6.82812 23.8557 6.82812C29.1379 6.82812 33.4885 10.7699 34.0599 15.8394M14.2243 20.5004C15.2386 20.6971 16.1814 21.0906 17.0104 21.639M27.2784 15.8614C28.3488 15.4875 29.5007 15.284 30.7009 15.284C31.8773 15.284 33.0073 15.4795 34.0599 15.8394M34.0599 15.8394C38.0812 17.2145 40.9688 20.9895 40.9688 25.431C40.9688 30.2951 37.5055 34.36 32.8828 35.3485",
    stroke: "#2783EC",
    strokeWidth: 2.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30.1875V40.9688M23 30.1875L26.5938 33.7812M23 30.1875L19.4062 33.7812",
    stroke: "#2783EC",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadFile);
export default __webpack_public_path__ + "static/media/icon-uploadFile.4e31109316c7f3601e175ffee61a8e80.svg";
export { ForwardRef as ReactComponent };